export const APPLE_SDK_SCRIPT_SOURCE_URL =
  'https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_GB/appleid.auth.js';

export const APPLE_SCRIPT_LOAD_EVENT_NAME = 'appleScriptLoaded';

export const FIVE_MINUTE_EXPIRY = 300;
export const COOKIE_ACCOUNT_LINKING_TOKEN_OPTIONS = {
  path: '/',
  maxAge: FIVE_MINUTE_EXPIRY,
  secure: true,
};
export const COOKIE_ACCOUNT_LINKING_TOKEN_APPLE = 'pre_al_token_apple';
export const COOKIE_ACCOUNT_LINKING_DETAILS_APPLE = 'pre_al_details_apple';
export const COOKIE_ACCOUNT_LINKING_TOKEN_GOOGLE = 'pre_al_token_google';
export const COOKIE_ACCOUNT_LINKING_DETAILS_GOOGLE = 'pre_al_details_google';
export const COOKIE_ACCOUNT_LINKING_TOKEN_EBAY = 'pre_al_token_ebay';
export const COOKIE_ACCOUNT_LINKING_MFA = 'pre_al_mfa';
export const COOKIE_MFA_TOKEN = 'pre_mfa_token';
export const COOKIE_MFA_DEVICE_ID = 'mfa_device_id';
export const COOKIE_MFA_CHALLENGE_ID = 'mfa_challenge_id';
export const COOKIE_MFA_PHONE_NUMBER = 'mfa_phone_number';

export const COOKIE_ACCOUNT_LINKING_SSO_EMAIL = 'SSOEmail';

export const ONE_HOUR_EXPIRY = 3600;
export const COOKIE_MFA_TOKEN_OPTS = {
  path: '/',
  maxAge: ONE_HOUR_EXPIRY,
  secure: true,
};

export const GENERIC_ERROR = 'An unknown error has occurred';

export const EBAY_SSO_STATE_STORAGE_KEY = 'ebay_sso_state';
export const EBAY_SSO_PENDING_RESULT_STORAGE_KEY = 'ebay_sso_pending_result';
export const EBAY_SSO_STORAGE_TTL_MS = 10 * 60 * 1000;
export const EBAY_SSO_MESSAGE_TYPE = 'ebay-sso-callback';
export const EBAY_POPUP_WINDOW_NAME = 'ebay-sso';
export const EBAY_POPUP_WIDTH = 600;
export const EBAY_POPUP_HEIGHT = 700;
export const EBAY_POPUP_POLL_INTERVAL_MS = 500;

export const APPLE_REDIRECT_URI = {
  '/login/': '/login/',
  '/signup/': '/signup/',
  '/magic-link/': '/signup/',
};
